// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"0745d805","239":"c176754a","455":"665fb72f","977":"99fea8b0"}[chunkId] + ".chunk.js";
};